import { styled } from '@auth0/quantum-product';
export var FormContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        marginTop: theme.spacing(3),
    });
});
